//Invoices and Spoilage
import React, { Component } from 'react'
import Swal from "sweetalert2";
import "../css/general-style.css"
import '../css/dashboard.css'
import LoadingWindow from '../components/LoadingWindow';
import { AiOutlineComment, AiOutlineUser } from "react-icons/ai";
import { FiTrash, FiSave } from "react-icons/fi";
import { BsFileText } from "react-icons/bs";
import { Menu } from "../components/Menu/Menu";
import CustomerList from '../components/CustomerList';
import InvoiceListCustomerNo from '../components/InvoiceListCustomerNo';
import { getValueCookie } from '../services/cookieService';
import { create_Delete_Update_Information, create_Delete_Update_InformationV3, getInformationWithData, getInformationWithDataV3 } from '../services/CABE';
import { Contains, DecimalPart, DeleteCharacter, MobileDisp, NumberFormat, validateNumbersForQuantitys } from '../functions/generalFunctions';
import ARDivisionList from '../components/ARDivisionList';
import { pricesFormat } from '../functions/pricesFormat';
import { DateFormatMAS90, getDateYearMonthDayDash } from '../functions/dateFormat';
import { confirmCloseAlert } from '../functions/alerts';
import { InvoicePDF } from '../components/InvoicePDF';
import { InvoicePDF2 } from '../components/InvoicePDF2';
import { InvoiceZebra } from '../components/InvoiceZebra/InvoiceZebra';
import { DownloadInvoicePDF2 } from '../components/DownloadInvoicePDF2';
import { DownloadInvoicePDF } from '../components/DownloadInvoicePDF';
import Select from 'react-select';
import SpoilageListSalesPerson from '../components/SpoilageListSalesPerson';
import { buildInvoiceNo } from '../functions/documentPrefix';
import CatalogueSpoilage from '../components/CatalogueSpoilage/CatalogueSpoilage';
export default class AccountsReceivable extends Component {
    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }

    state = {
        Accounts: {
            InvoiceNo: '',
            InvoiceDate: getDateYearMonthDayDash(),
            BatchNo: '',
            InvoiceType: '',
            Type: '',
            SalespersonNo: '',
            Comment: '',
            FreightAmt: 0,
            Customer: {
                AddressLine1: '',
                City: '',
                CountryCode: '',
                CreditLimit: 0,
                CustomerName: '',
                CustomerNo: '',
                EmailAddress: '',
                FaxNo: '',
                PriceLevel: '',
                SalespersonNo: '',
                State: '',
                TaxSchedule: '',
                TelephoneNo: '',
                TermsCode: '',
                UDF_RUTA: '',
                ZipCode: '',
            },
            TotalQuantityOrdered: 0,
            TotalCost: 0,
            TotalQuantityShipped: 0,
            TotalWeight: 0,
            SalesOrderNo: '',
            ApplyToInvoiceNo: ''
        },
        FilterProducts: [],
        Products: [],
        ARDetail: [],
        PrintDetail: [],
        confirmPrint: true,
        options: [],
        select: {
            label: null, value: null
        }
    }


    async getNewCorrelativeInvoiceNumber() {

        const data = {
            type: 'InvoiceNumber',
            idCompany: getValueCookie('CompanyId')
        }
        const result = await getInformationWithDataV3('/sales/get/correlative', data)
        if (result.status.code === 1) {
            const temporal = buildInvoiceNo(result.data[0].correlative)
            const temp = this.state.Accounts
            temp.InvoiceNo = temporal
            this.setState({ Accounts: temp })
        }
    }

    onTarget = (e, item) => {
        const searchValue = e.target.value;
        const idInput = e.target.id.split('_')
        if (idInput.length === 1) {
            switch (idInput[0]) {
                case 'SearchItemAccountsReceivable':
                    let FiltProducts = this.state.Products.filter((item) => {
                        if (((
                            Contains(item.itemCode, searchValue) ||
                            Contains(item.abbreviatedDesc, searchValue)
                        ))
                        ) {
                            return item
                        } else {
                            return null
                        }
                    });
                    this.setState({ FilterProducts: FiltProducts });
                    break;
                default:
                    break;
            }
        } else {
            const temporal = this.state.ARDetail
            const index = temporal.indexOf(item)
            if (index !== -1) {
                if (idInput[0] === 'totalAmountAR') {
                    temporal[index].ItemTotalAmt = Number(searchValue)
                    this.setState({ ARDetail: temporal })
                    this.calculateTotals()
                }
            }
        }




    }

    addComentary(item) {
        let comm = item.ItemComment
        Swal.fire({
            title: 'Product: ' + DeleteCharacter(item.itemCode, '/'),
            html: `<div class='textAreaGeneral textAreaComment'>
                    <textarea id='comentOfAR' rows="10" cols="50">${comm}</textarea>
                   </div>
            `,
            backdrop: true,
            showCancelButton: true,
            confirmButtonText: 'Save Commentary',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                const temporal = this.state.ARDetail
                const index = temporal.indexOf(item)
                if (index !== -1) {
                    const coment = Swal.getPopup().querySelector('#comentOfAR').value
                    temporal[index].ItemComment = coment
                    this.setState({ ARDetail: temporal })
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        })
    }
    removeAR(item) {

        const temporal = this.state.ARDetail
        const index = temporal.indexOf(item)
        if (index !== -1) {
            //temporal.splice(index, 1)

            if (this.state.select.label === 'SPOILAGE') {
                temporal[index].quantityShipped = item.quantityShipped
                temporal[index].quantityReturned = 0
                temporal[index].UnitPrice = item.UnitPrice
                temporal[index].Total = 0
                temporal[index].ItemComment = ''
            } else {
                temporal[index].ItemComment = " "
                temporal[index].ItemTotalAmt = 0
            }
            temporal[index].Visible = false
            this.setState({ ARDetail: temporal })
            this.refreshInputs()
        }
        this.calculateTotals()

    }



    async AuthorizeAR() {
        if (this.state.Accounts.SalespersonNo === '') {
            let temp = this.state.Accounts
            temp.SalespersonNo = getValueCookie('SalesPerson')
            this.setState({ Accounts: temp })
        }


        let detail = []
        let printdetail = []
        let cont = 1
        if (this.state.select.label === 'SPOILAGE') {

            for (const item of this.state.ARDetail) {

                detail.push({
                    ItemCode: '/SPOILAGE',
                    ItemType: '3',
                    ItemCodeDesc: 'Spoilage',
                    ItemComment: item.itemCode + '/' + item.ItemComment,
                    ItemTotalAmt: item.Total,
                    LineSeqNo: cont
                })
                if (item.Visible) {

                    printdetail.push({
                        ItemCode: '/SPOILAGE',
                        ItemCode2: item.itemCode,
                        Description: (item.completeDesc !== "" && item.completeDesc !== null && item.completeDesc !== undefined) ? item.completeDesc : item.abbreviatedDesc,
                        UnitPrice: Number(item.UnitPrice).toFixed(2),
                        quantityReturned: item.quantityReturned,
                        ItemType: '3',
                        ItemCodeDesc: 'Spoilage',
                        ItemComment: item.itemCode + '/' + item.ItemComment,
                        Comment:item.ItemComment,
                        ItemTotalAmt: item.Total,
                        LineSeqNo: cont
                    })
                }
                cont++
            }

        } else {
            detail = this.state.ARDetail
            for (const item of detail) {
                item.LineSeqNo = cont
                if (item.Visible) {
                    printdetail.push(item)
                }
                cont++
            }
        }
        let temporal = this.state.Accounts
        temporal.InvoiceType = this.state.select.label === 'SPOILAGE' || this.state.select.label === 'SALES DISCOUNT' ? 'CM' : 'IN'

        const data = {
            Account: temporal,
            Products: this.state.Products,
            ARDetail: detail,
            OrderType: "InvoiceAR",
            idCompany: Number(getValueCookie('CompanyId')),
            username: getValueCookie('userName'),
            company: getValueCookie('Company')
        }


        // backv2 (regresar aquí si falla la prueba): const result = await create_Delete_Update_Information('/invoice/setAR', data)
        const result = await create_Delete_Update_InformationV3('/invoice/setAR', data)
        await this.setState({ PrintDetail: printdetail })


        if (result.status.code === 1) {

            confirmCloseAlert('correct', 'The Account Receivable was saved successfully!')
            this.printAlert()

        } else {
            confirmCloseAlert('incorrect', 'Whoops something is wrong. Please try again!')
        }

    }

    clearAll() {
        this.setState({
            Accounts: {
                InvoiceNo: '',
                InvoiceDate: getDateYearMonthDayDash(),
                BatchNo: '',
                InvoiceType: '',
                Type: '',
                SalespersonNo: '',
                Comment: '',
                FreightAmt: 0,
                Customer: {
                    AddressLine1: '',
                    City: '',
                    CountryCode: '',
                    CreditLimit: 0,
                    CustomerName: '',
                    CustomerNo: '',
                    EmailAddress: '',
                    FaxNo: '',
                    PriceLevel: '',
                    SalespersonNo: '',
                    State: '',
                    TaxSchedule: '',
                    TelephoneNo: '',
                    TermsCode: '',
                    UDF_RUTA: '',
                    ZipCode: '',
                },
                TotalQuantityOrdered: 0,
                TotalCost: 0,
                TotalQuantityShipped: 0,
                TotalWeight: 0,
                SalesOrderNo: '',
                ApplyToInvoiceNo: ''
            },
            FilterProducts: [],
            Products: [],
            ARDetail: [],
            PrintDetail: [],
            confirmPrint: true
        })

    }
    textTermsCode(num) {
        switch (Number(num)) {
            case 0:
                return 'Pay in Advance'
            case 1:
                return 'FOB Taiwan'
            case 7:
                return 'Net 07 Days'
            case 10:
                return 'Net 10 Days'
            case 15:
                return 'Net 15 Days'
            case 21:
                return 'Net 21 Days'
            case 30:
                return 'Net 30 Days'
            case 45:
                return 'Net 45 Days'
            default:
                return ''
        }

    }

    printDetail(type) {
        let detail = []

        if (type === 'Zebra') {
            this.state.PrintDetail.forEach(element => {
                const It = {
                    ItemCode: DeleteCharacter(element.ItemCode, '/'),
                    ItemCodeDesc: element.ItemCodeDesc,
                    ItemComment: element.ItemComment,
                    Comment:element.Comment,
                    ItemTotalAmt: element.ItemTotalAmt,
                    ItemType: element.ItemType,
                    ItemCode2: element.ItemCode2,
                    Description: element.Description,
                    UnitPrice: element.UnitPrice,
                    quantityReturned: element.quantityReturned,
                }
                detail.push(It)
            });

        } else {

            this.state.PrintDetail.forEach(element => {
                const It = {
                    ItemCode: DeleteCharacter(element.ItemCode, '/'),
                    ItemCodeDesc: element.ItemCodeDesc,
                    ItemComment: element.ItemComment,
                    Comment:element.Comment,
                    ItemTotalAmt: element.ItemTotalAmt,
                    ItemType: element.ItemType,
                    ItemCode2: element.ItemCode2,
                    Description: element.Description,
                    UnitPrice: element.UnitPrice,
                    quantityReturned: element.quantityReturned,

                }
                detail.push(It)
            });
            const tamBreak = 55
            const res = detail.length % tamBreak
            for (let a = 0; a < tamBreak - res; a++) {
                const itemJson = {
                    ItemCode: " ",
                    ItemCodeDesc: " ",
                    ItemComment: " ",
                    Comment:" ",
                    ItemTotalAmt: " ",
                    ItemType: " ",
                    ItemCode2: " ",
                    Description: " ",
                    UnitPrice: " ",
                    quantityReturned: " ",
                }
                detail.push(itemJson)

            }
        }






        return detail
    }

    realLongDetail() {
        let cont = 0
        this.state.PrintDetail.forEach(() => {
            cont++

        });
        return cont
    }

    calculateTotals() {

        let totalCost = 0
        let quantity = 0
        let Shipped = 0
        const temporal = this.state.ARDetail
        const temporal2 = this.state.Accounts
        if (this.state.select.label === 'SPOILAGE') {
            for (const item of temporal) {
                quantity += Number(item.quantityReturned)
                Shipped += Number(item.quantityShipped)
                totalCost += Number(item.Total)
            }

            temporal2.TotalCost = totalCost.toFixed(2)
            temporal2.TotalQuantityShipped = Shipped.toFixed(2)
            temporal2.TotalQuantityOrdered = quantity.toFixed(2)
            this.setState({ Accounts: temporal2 })

        } else {

            for (const item of temporal) {

                totalCost += Number(item.ItemTotalAmt)
            }

            temporal2.TotalCost = totalCost.toFixed(2)
            temporal2.TotalQuantityShipped = Shipped.toFixed(2)
            temporal2.TotalQuantityOrdered = quantity.toFixed(2)
            this.setState({ Accounts: temporal2 })
        }

    }

    printAlert() {
        Swal.fire({
            title: 'Do you want to print this Accounts Receivable:',
            showDenyButton: true,
            showConfirmButton: true,
            denyButtonText: 'No, thanks!',
            confirmButtonText: 'Yes, please',
            confirmButtonColor: '#26117A',
            denyButtonColor: '#D05416',

        }).then(async (result) => {
            if (result.isConfirmed) {
                if (document.getElementById('InvoicePrintAR')) {
                    var button1 = document.getElementById('InvoicePrintAR')
                    if (button1) {
                        await button1.click()
                    }
                }
            } else if (result.isDenied) {
                //this.clearAll()
            }
        })
    }

    openPrint() {

        if (document.getElementById('InvoicePrintAR')) {
            let button = document.getElementById('InvoicePrintAR')
            button.click()

        }
    }
    handleChange(e) {
        const change = e
        this.setState({ select: change })
        this.clearAll()
    }

    refreshInputs() {
        const temporal = this.state.ARDetail
        if (this.state.select.label === 'SPOILAGE') {
            for (let a = 0; a < temporal.length; a++) {

                document.getElementById("quantityReturnedSpoilage_" + a).value = temporal[a].quantityReturned
                document.getElementById("unitPriceSpoilage_" + a).value = temporal[a].UnitPrice
            }
        } else {
            for (let a = 0; a < temporal.length; a++) {
                document.getElementById("totalAmountAR_" + a).value = temporal[a].ItemTotalAmt
            }
        }

    }

    changeSpoilageDetail = async (e, item) => {
        const temporal = this.state.ARDetail
        const ident = e.target.id.split('_')
        const index = temporal.indexOf(item)

        if (index !== -1) {
            if (ident[0] === "quantityReturnedSpoilage") {
                let quant = Number(e.target.value)

                if (!validateNumbersForQuantitys(quant)) {
                    let parteDecimal = 1 - DecimalPart(quant)
                    quant += parteDecimal
                    document.getElementById(e.target.id).value = quant
                }

                temporal[index].quantityReturned = Number(quant)
                temporal[index].Total = (Number(quant) * Number(temporal[index].UnitPrice))
                this.setState({ ARDetail: temporal })
                this.calculateTotals()
            } else if (ident[0] === "unitPriceSpoilage") {
                temporal[index].UnitPrice = Number(e.target.value)
                temporal[index].Total = (Number(e.target.value) * Number(temporal[index].quantityReturned))

                this.setState({ ARDetail: temporal })
                this.calculateTotals()
            }


        }

    }

    async getAROPtions() {
        const data = {
            idCompany: Number(getValueCookie('CompanyId'))
        }
        const respuesta = await getInformationWithData('/Items/AR', data);

        let options = []
        let count = 1
        for (const item of respuesta.result) {
            let temporal = { label: DeleteCharacter(item.ItemCode, '/'), value: count }
            options.push(temporal)
            if (this.state.select.label === null && temporal.label === 'SPOILAGE') {

                this.setState({ select: temporal })
            }
            count++
        }
        this.setState({ options: options })
    }



    render() {
        const hasMode = this.state.select.label !== null;
        const hasCustomer = !!this.state.Accounts.Customer.CustomerNo;
        const hasInvoice = !!this.state.Accounts.InvoiceNo;
        const cust = this.state.Accounts.Customer;
        const acc = this.state.Accounts;
        const isSpoilage = this.state.select.label === 'SPOILAGE';
        const isFreight = this.state.select.label === 'FREIGHT';

        const kvStyle = { display: 'flex', flexDirection: 'column', gap: '2px' };
        const labelStyle = { fontSize: '0.68rem', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.05em' };
        const valStyle = { fontWeight: 700, color: '#0F172A', fontSize: '0.875rem' };
        const inputStyle = { width: '100%', border: '1.5px solid #E2E8F0', borderRadius: '6px', padding: '4px 8px', fontSize: '0.875rem' };

        return (
            <div className="dash-page" style={{ paddingTop: '70px' }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '1.25rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <BsFileText style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Accounts Receivable</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
                            {hasInvoice ? `Invoice ${acc.InvoiceNo} · ${this.state.select.label}` : 'Select a mode and customer to create an AR'}
                        </p>
                    </div>
                    {hasInvoice && (
                        <span style={{ background: 'rgba(255,255,255,0.15)', color: 'white', borderRadius: '999px', padding: '0.3rem 1rem', fontSize: '0.8rem', fontWeight: 700 }}>
                            Total: ${NumberFormat(pricesFormat(Number(acc.FreightAmt) + Number(acc.TotalCost)))}
                        </span>
                    )}
                </div>

                <div style={{ padding: '1.5rem 2rem', display: 'flex', gap: '1.25rem', alignItems: 'flex-start' }}>

                    {/* LEFT SIDEBAR */}
                    <div style={{ width: '260px', flexShrink: 0, position: 'sticky', top: '80px', display: 'flex', flexDirection: 'column', gap: '1rem' }}>

                        {/* Mode selector */}
                        <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '16px', overflow: 'hidden' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                                <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Mode</span>
                            </div>
                            <div style={{ padding: '0.875rem 1rem' }}>
                                <Select onMenuOpen={() => this.getAROPtions()} value={this.state.select} options={this.state.options} className='text-start' placeholder="Select Mode" onChange={this.handleChange.bind(this)}
                                    menuPortalTarget={document.body} menuPosition='fixed'
                                    styles={{ control: (b) => ({ ...b, fontSize: '0.875rem', minHeight: '36px', borderRadius: '8px', borderColor: '#E2E8F0' }), menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
                            </div>
                        </div>

                        {/* Customer selector */}
                        <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '16px', overflow: 'hidden' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <AiOutlineUser style={{ color: 'rgba(255,255,255,0.7)' }} />
                                <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Customer</span>
                            </div>
                            <div style={{ padding: '0.875rem 1rem', display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
                                <CustomerList disabled={!hasMode} headerName='Customer' nombrePadre="Accounts" Padre={this} ident="AccountCustomerList1" />
                                {hasCustomer ? (
                                    <div style={{ borderTop: '1px solid #F1F5F9', paddingTop: '0.75rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                        <div style={{ fontWeight: 800, color: '#0F172A', fontSize: '0.875rem' }}>{cust.CustomerName}</div>
                                        <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '5px', padding: '1px 7px', fontSize: '0.72rem', fontWeight: 700, alignSelf: 'flex-start' }}>{cust.CustomerNo}</span>
                                        {[
                                            { l: 'City', v: cust.City },
                                            { l: 'State', v: cust.State },
                                            { l: 'Phone', v: cust.TelephoneNo },
                                            { l: 'Terms', v: this.textTermsCode(cust.TermsCode) },
                                        ].filter(f => f.v).map((f, i) => (
                                            <div key={i} style={kvStyle}><span style={labelStyle}>{f.l}</span><span style={{ ...valStyle, fontSize: '0.8rem' }}>{f.v}</span></div>
                                        ))}
                                    </div>
                                ) : (
                                    <p style={{ color: '#94A3B8', fontSize: '0.8rem', margin: 0, textAlign: 'center' }}>No customer selected</p>
                                )}
                            </div>
                        </div>

                        {/* Invoice info */}
                        {hasInvoice ? (
                            <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '16px', overflow: 'hidden' }}>
                                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                                    <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Invoice</span>
                                </div>
                                <div style={{ padding: '0.875rem 1rem', display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
                                    <div style={kvStyle}><span style={labelStyle}>Invoice No</span><span style={valStyle}>{acc.InvoiceNo}</span></div>
                                    {!isFreight && acc.ApplyToInvoiceNo && <div style={kvStyle}><span style={labelStyle}>Apply to Invoice</span><span style={valStyle}>{acc.ApplyToInvoiceNo}</span></div>}
                                    <div style={kvStyle}><span style={labelStyle}>Total</span><span style={{ ...valStyle, color: '#059669', fontSize: '1rem' }}>${NumberFormat(pricesFormat(Number(acc.FreightAmt) + Number(acc.TotalCost)))}</span></div>
                                </div>
                            </div>
                        ) : null}

                        {/* Save button */}
                        {hasInvoice ? (
                            <button disabled={!this.state.confirmPrint} type="button" onClick={() => this.AuthorizeAR()}
                                style={{ background: 'linear-gradient(135deg, #065F46, #059669)', color: 'white', border: 'none', borderRadius: '10px', padding: '0.65rem', fontWeight: 700, fontSize: '0.875rem', cursor: 'pointer', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem' }}>
                                <FiSave /> Save Invoice &amp; Print
                            </button>
                        ) : null}
                    </div>

                    {/* RIGHT MAIN */}
                    <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '1rem' }}>

                        {/* Invoice actions row */}
                        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                            <div style={{ flex: 1, minWidth: '200px' }}>
                                <InvoiceListCustomerNo hidden={isFreight} disabled={!hasCustomer} CustomerNo={acc.Customer.CustomerNo} headerName='' buttonTitle="Select Invoice to Apply" nombrePadre="AccountsListCustomer" Padre={this} />
                            </div>
                            <div style={{ flex: 1, minWidth: '200px' }}>
                                <SpoilageListSalesPerson hidden={false} disabled={false} headerName='' nombrePadre="SpoilageListSalesPerson" Padre={this} />
                            </div>
                            <div hidden={true}>
                                <SpoilageListSalesPerson hidden={true} disabled={true} headerName='' nombrePadre="SpoilageListHistorySalesPerson" Padre={this} />
                            </div>
                        </div>

                        {/* AR Division + Catalogue Spoilage */}
                        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                            <ARDivisionList SelectARDiv={this.state.select.label} type={this.state.select.value} hidden={isSpoilage || !hasInvoice} disabled={!hasCustomer} headerName='' nombrePadre="ARListAccountReceivable" colorButton='blueButton' Padre={this} />
                            <CatalogueSpoilage hidden={!isSpoilage || !hasInvoice} Invoice={acc.ApplyToInvoiceNo} detail={this.state.Products} mode={this.state.select.label} Padre={this} needPrice={true} needCost={false} />
                        </div>

                        {/* Hint */}
                        {!hasCustomer && hasMode ? (
                            <div style={{ background: 'rgba(37,99,235,0.06)', border: '1px solid #BFDBFE', borderRadius: '10px', padding: '0.875rem 1.25rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                <AiOutlineUser style={{ color: '#1e40af', fontSize: '1.1rem', flexShrink: 0 }} />
                                <span style={{ color: '#1e40af', fontSize: '0.875rem', fontWeight: 600 }}>Select a customer using the button in the left panel to continue.</span>
                            </div>
                        ) : null}

                        {/* Detail table */}
                        {this.state.ARDetail.some(i => i.Visible) ? (
                            <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '12px', overflow: 'hidden' }}>
                                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>
                                        {isSpoilage ? 'Spoilage Detail' : 'AR Detail'}
                                    </span>
                                    {acc.ApplyToInvoiceNo ? (
                                        <span style={{ background: 'rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.85)', borderRadius: '5px', padding: '1px 8px', fontSize: '0.72rem', fontWeight: 700 }}>
                                            Applied to: {acc.ApplyToInvoiceNo}
                                        </span>
                                    ) : null}
                                </div>
                                <div className="tableFixHeadSmall">
                                    {isSpoilage ? (
                                        <table className='table table-clean mb-0'>
                                            <thead>
                                                <tr className="text-center">
                                                    <th>Item Code</th><th className="text-start">Description</th>
                                                    <th>Qty Shipped</th><th>Qty Returned</th>
                                                    <th>Unit Price</th><th className="text-end">Total</th>
                                                    <th style={{ width: 36 }}></th><th style={{ width: 36 }}></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.ARDetail.map((item, i) => (
                                                    <tr hidden={!item.Visible} key={i}>
                                                        <td className="text-center">
                                                            <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{item.itemCode}</span>
                                                        </td>
                                                        <td style={{ fontSize: '0.875rem', color: '#334155' }}>{(item.completeDesc !== "null" && item.completeDesc) ? item.completeDesc : item.abbreviatedDesc}</td>
                                                        <td className="text-center" style={{ color: '#64748B', fontSize: '0.875rem' }}>{pricesFormat(item.quantityShipped)}</td>
                                                        <td>
                                                            <input type="number" id={'quantityReturnedSpoilage_' + i} min={0} defaultValue={item.quantityReturned} onChange={(e) => this.changeSpoilageDetail(e, item)} style={{ ...inputStyle, width: '70px', textAlign: 'center' }} />
                                                        </td>
                                                        <td>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '2px', justifyContent: 'flex-end' }}>
                                                                <span style={{ color: '#64748B', fontSize: '0.8rem' }}>$</span>
                                                                <input type="number" id={'unitPriceSpoilage_' + i} min={0} step={0.01} defaultValue={Number(item.UnitPrice).toFixed(2)} onChange={(e) => this.changeSpoilageDetail(e, item)} style={{ ...inputStyle, width: '78px', textAlign: 'right' }} />
                                                            </div>
                                                        </td>
                                                        <td className="text-end" style={{ fontWeight: 700, color: '#059669' }}>$ {NumberFormat(Number(item.Total).toFixed(2))}</td>
                                                        <td>
                                                            <button type="button" onClick={() => this.addComentary(item)} style={{ background: '#F1F5F9', border: 'none', borderRadius: '6px', padding: '4px 8px', cursor: 'pointer', color: '#64748B' }}><AiOutlineComment /></button>
                                                        </td>
                                                        <td>
                                                            <button type="button" onClick={() => this.removeAR(item)} style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid #FECACA', borderRadius: '6px', padding: '4px 8px', cursor: 'pointer', color: '#DC2626' }}><FiTrash /></button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot className="tfoot">
                                                <tr>
                                                    <td></td><td>Totals</td>
                                                    <td className="text-center" style={{ fontWeight: 700 }}>{acc.TotalQuantityShipped}</td>
                                                    <td className="text-center" style={{ fontWeight: 700 }}>{acc.TotalQuantityOrdered}</td>
                                                    <td></td>
                                                    <td className="text-end" style={{ fontWeight: 700, color: '#059669' }}>$ {acc.TotalCost}</td>
                                                    <td></td><td></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    ) : (
                                        <table className='table table-clean mb-0'>
                                            <thead>
                                                <tr>
                                                    <th>AR Code</th><th>Type</th><th>Description</th><th className="text-end">Total Amount</th>
                                                    <th style={{ width: 36 }}></th><th style={{ width: 36 }}></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.ARDetail.map((item, i) => (
                                                    <tr hidden={!item.Visible} key={i}>
                                                        <td>
                                                            <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{DeleteCharacter(item.ItemCode, '/')}</span>
                                                        </td>
                                                        <td style={{ color: '#64748B', fontSize: '0.8rem' }}>{item.ItemType}</td>
                                                        <td style={{ fontSize: '0.875rem', color: '#334155' }}>{item.ItemCodeDesc}</td>
                                                        <td>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '2px', justifyContent: 'flex-end' }}>
                                                                <span style={{ color: '#64748B', fontSize: '0.8rem' }}>$</span>
                                                                <input type="number" id={'totalAmountAR_' + i} min={0} step={0.01} defaultValue={Number(item.ItemTotalAmt).toFixed(2)} onChange={(e) => this.onTarget(e, item)} style={{ ...inputStyle, width: '100px', textAlign: 'right' }} />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <button type="button" onClick={() => this.addComentary(item)} style={{ background: '#F1F5F9', border: 'none', borderRadius: '6px', padding: '4px 8px', cursor: 'pointer', color: '#64748B' }}><AiOutlineComment /></button>
                                                        </td>
                                                        <td>
                                                            <button type="button" onClick={() => this.removeAR(item)} style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid #FECACA', borderRadius: '6px', padding: '4px 8px', cursor: 'pointer', color: '#DC2626' }}><FiTrash /></button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot className="tfoot"><tr></tr></tfoot>
                                        </table>
                                    )}
                                </div>
                            </div>
                        ) : null}

                        {/* Print buttons (hidden, triggered programmatically) */}
                    </div>
                </div>

                {/* Print buttons section — kept hidden, triggered by AuthorizeAR */}
                <div hidden={!hasInvoice} style={{ padding: '0 2rem 2rem', display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                    <div style={{ display: 'none' }}>{/* hidden print section start */}</div>
                    <div className='col-sm-10'>
                        <div className='row d-flex justify-content-center'>
                            <div className='col-sm-12 col-md-5 d-grid gap-2 pb-2'>
                                <button disabled={!this.state.confirmPrint} type="button" className="btn greenButton btn-lg" onClick={() => this.AuthorizeAR()}><FiSave /> Save Invoice And Print</button>
                            </div>
                            <div className='col-sm-12 col-md-5 d-grid gap-2 pb-2'>
                                {getValueCookie('CompanyId') === '6' ?
                                    (MobileDisp() ?
                                        <InvoicePDF2
                                            id={'InvoicePrintAR'}
                                            hidden={true}
                                            disabled={false}
                                            colorButton='blackButton'
                                            titleButton='Invoice Print'
                                            title='Invoice Print'
                                            companyLogo={getValueCookie('DocumentsLogo')}
                                            InvoiceType={this.state.select.label}
                                            CompanyContactInfo={['Altitude LLC', '7055 Amwiler Industrial Dr', 'Suite B-C', '(770) 871-5807']}
                                            InvoiceHeader={['Invoice Number:', this.state.Accounts.InvoiceNo, 'Invoice Date:', DateFormatMAS90(this.state.Accounts.InvoiceDate), 'Sales Person:', this.state.Accounts.SalespersonNo, 'Customer Number:', this.state.Accounts.Customer.CustomerNo]}

                                            Box1={[this.state.Accounts.Customer.CustomerName, this.state.Accounts.Customer.AddressLine1, this.state.Accounts.Customer.City + ", " + this.state.Accounts.Customer.State + " " + this.state.Accounts.Customer.ZipCode]}
                                            Box2={[this.state.Accounts.Customer.CustomerName, this.state.Accounts.Customer.AddressLine1, this.state.Accounts.Customer.City + ", " + this.state.Accounts.Customer.State + " " + this.state.Accounts.Customer.ZipCode]}
                                            HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", "Pay in Advance"]}
                                            DescriptionKeys={this.state.select.label === 'SPOILAGE' ? ["quantityReturned", "ItemCode2", "Description", "Comment", "$", "UnitPrice", "$", "ItemTotalAmt"] : ["ItemCode", "ItemCodeDesc", "ItemComment", "$", "ItemTotalAmt"]}
                                            HeaderDescritpion={this.state.select.label === 'SPOILAGE' ? ["Qty", "ItemCode", "Description", "Comment", "", "UnitPrice", "", "Amount"] : ["Code", "Description", "Comment", "", "Amount"]}
                                            StyleDetail={this.state.select.label === 'SPOILAGE' ? ["ColumnaCantidades", "ColumnaNormalLeft", "ColumnaGrande", "ColumnaGrande", "Simbolo", "ColumnaMonetariaRight", "Simbolo", "ColumnaMonetariaRight"] : ["ColumnaNormalLeft", "ColumnaGrande", "ColumnaGrande", "Simbolo", "ColumnaMonetariaRight"]}
                                            Detail={this.printDetail()}
                                            breakpoint={65}
                                            quantSignDolar={this.realLongDetail()}
                                            keysDecimalFormat={["ItemTotalAmt"]}
                                            bottomInformation={[
                                                this.state.Accounts.TotalQuantityOrdered, "", "", "", "", "", "", "", "Invoice Total: ", "$", NumberFormat(pricesFormat(Number(this.state.Accounts.FreightAmt) + Number(this.state.Accounts.TotalCost)))
                                            ]}
                                            bottomStyle={[
                                                "NormalButtom", "ClearBottom", "NormalButtom", "ClearBottom", "NormalButtom", "ClearBottom", "ClearBottom", "LargeButtom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                            ]}
                                            bottomMessage={""}

                                        />
                                        :
                                        <DownloadInvoicePDF2
                                            id={'InvoicePrintAR'}
                                            hidden={true}
                                            disabled={false}
                                            colorButton='blackButton'
                                            titleButton='Invoice Print'
                                            title='Invoice Print'
                                            companyLogo={getValueCookie('DocumentsLogo')}
                                            InvoiceType={this.state.select.label}
                                            CompanyContactInfo={['Altitude LLC', '7055 Amwiler Industrial Dr', 'Suite B-C', '(770) 871-5807']}
                                            InvoiceHeader={['Invoice Number:', this.state.Accounts.InvoiceNo, 'Invoice Date:', DateFormatMAS90(this.state.Accounts.InvoiceDate), 'Sales Person:', this.state.Accounts.SalespersonNo, 'Customer Number:', this.state.Accounts.Customer.CustomerNo]}

                                            Box1={[this.state.Accounts.Customer.CustomerName, this.state.Accounts.Customer.AddressLine1, this.state.Accounts.Customer.City + ", " + this.state.Accounts.Customer.State + " " + this.state.Accounts.Customer.ZipCode]}
                                            Box2={[this.state.Accounts.Customer.CustomerName, this.state.Accounts.Customer.AddressLine1, this.state.Accounts.Customer.City + ", " + this.state.Accounts.Customer.State + " " + this.state.Accounts.Customer.ZipCode]}
                                            HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", "Pay in Advance"]}
                                            DescriptionKeys={this.state.select.label === 'SPOILAGE' ? ["quantityReturned", "ItemCode2", "Description", "Comment", "$", "UnitPrice", "$", "ItemTotalAmt"] : ["ItemCode", "ItemCodeDesc", "ItemComment", "$", "ItemTotalAmt"]}
                                            HeaderDescritpion={this.state.select.label === 'SPOILAGE' ? ["Qty", "ItemCode", "Description", "Comment", "", "UnitPrice", "", "Amount"] : ["Code", "Description", "Comment", "", "Amount"]}
                                            StyleDetail={this.state.select.label === 'SPOILAGE' ? ["ColumnaCantidades", "ColumnaNormalLeft", "ColumnaGrande", "ColumnaGrande", "Simbolo", "ColumnaMonetariaRight", "Simbolo", "ColumnaMonetariaRight"] : ["ColumnaNormalLeft", "ColumnaGrande", "ColumnaGrande", "Simbolo", "ColumnaMonetariaRight"]}
                                            Detail={this.printDetail()}
                                            breakpoint={65}
                                            quantSignDolar={this.realLongDetail()}
                                            keysDecimalFormat={["ItemTotalAmt"]}
                                            bottomInformation={[
                                                this.state.Accounts.TotalQuantityOrdered, "", "", "", "", "", "", "", "Invoice Total: ", "$", NumberFormat(pricesFormat(Number(this.state.Accounts.FreightAmt) + Number(this.state.Accounts.TotalCost)))
                                            ]}
                                            bottomStyle={[
                                                "NormalButtom", "ClearBottom", "NormalButtom", "ClearBottom", "NormalButtom", "ClearBottom", "ClearBottom", "LargeButtom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                                "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "NormalButtom", "NormalButtom", "NormalButtom",
                                            ]}
                                            bottomMessage={""}

                                        />)
                                    :
                                    (
                                        MobileDisp() ?
                                            <InvoicePDF
                                                hidden={true}
                                                id={'InvoicePrintAR'}
                                                disabled={false}
                                                colorButton='blackButton'
                                                titleButton='Invoice Print'
                                                title='Invoice Print'
                                                CompanyTitle='Mayaland'
                                                InvoiceType={this.state.select.label}
                                                CompanyContactInfo={['Mayaland LLC', '7055 Amwiler Industrial Dr', 'Suite B-C', '(678) 213-1226']}
                                                InvoiceHeader={['Invoice Number:', this.state.Accounts.InvoiceNo, 'Invoice Date:', DateFormatMAS90(this.state.Accounts.InvoiceDate), 'Sales Person:', this.state.Accounts.SalespersonNo, 'Customer Number:', this.state.Accounts.Customer.CustomerNo]}
                                                Box1={[this.state.Accounts.Customer.CustomerName, this.state.Accounts.Customer.AddressLine1, this.state.Accounts.Customer.City + ", " + this.state.Accounts.Customer.State + " " + this.state.Accounts.Customer.ZipCode]}
                                                Box2={[this.state.Accounts.Customer.CustomerName, this.state.Accounts.Customer.AddressLine1, this.state.Accounts.Customer.City + ", " + this.state.Accounts.Customer.State + " " + this.state.Accounts.Customer.ZipCode]}
                                                HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", this.textTermsCode(this.state.Accounts.Customer.TermsCode)]}
                                                DescriptionKeys={["ItemCode", "ItemCodeDesc", "ItemComment", "$", "ItemTotalAmt"]}
                                                HeaderDescritpion={["Code", "Description", "Comment", "", "Amount"]}
                                                StyleDetail={["ColumnaNormal2", "ColumnaNormal2", "ColumnaGrande2", "Simbolo", "ColumnaMonetariaRight"]}
                                                Detail={this.printDetail()}
                                                breakpoint={55}
                                                quantSignDolar={this.realLongDetail()}
                                                keysDecimalFormat={["ItemTotalAmt"]}
                                                bottomInformation={[
                                                    "", "", "", "", "", "", "", "", "Invoice Total: ", "$", NumberFormat(pricesFormat(Number(this.state.Accounts.FreightAmt) + Number(this.state.Accounts.TotalCost)))
                                                ]}
                                                bottomStyle={[
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "LineButtom3Left", "DolarButtomLeft2", "LineButtom3"
                                                ]}
                                                bottomMessage={" "}
                                            />
                                            :
                                            <DownloadInvoicePDF
                                                hidden={true}
                                                id={'InvoicePrintAR'}
                                                disabled={false}
                                                colorButton='blackButton'
                                                titleButton='Invoice Print'
                                                title='Invoice Print'
                                                CompanyTitle='Mayaland'
                                                InvoiceType={this.state.select.label}
                                                CompanyContactInfo={['Mayaland LLC', '7055 Amwiler Industrial Dr', 'Suite B-C', '(678) 213-1226']}
                                                InvoiceHeader={['Invoice Number:', this.state.Accounts.InvoiceNo, 'Invoice Date:', DateFormatMAS90(this.state.Accounts.InvoiceDate), 'Sales Person:', this.state.Accounts.SalespersonNo, 'Customer Number:', this.state.Accounts.Customer.CustomerNo]}
                                                Box1={[this.state.Accounts.Customer.CustomerName, this.state.Accounts.Customer.AddressLine1, this.state.Accounts.Customer.City + ", " + this.state.Accounts.Customer.State + " " + this.state.Accounts.Customer.ZipCode]}
                                                Box2={[this.state.Accounts.Customer.CustomerName, this.state.Accounts.Customer.AddressLine1, this.state.Accounts.Customer.City + ", " + this.state.Accounts.Customer.State + " " + this.state.Accounts.Customer.ZipCode]}
                                                HeaderOptions={["Customer P.O.", "Ship VIA", "F.O.B.", "Terms", " ", " ", " ", this.textTermsCode(this.state.Accounts.Customer.TermsCode)]}
                                                DescriptionKeys={["ItemCode", "ItemCodeDesc", "ItemComment", "$", "ItemTotalAmt"]}
                                                HeaderDescritpion={["Code", "Description", "Comment", "", "Amount"]}
                                                StyleDetail={["ColumnaNormal2", "ColumnaNormal2", "ColumnaGrande2", "Simbolo", "ColumnaMonetariaRight"]}
                                                Detail={this.printDetail()}
                                                breakpoint={55}
                                                quantSignDolar={this.realLongDetail()}
                                                keysDecimalFormat={["ItemTotalAmt"]}
                                                bottomInformation={[
                                                    "", "", "", "", "", "", "", "", "Invoice Total: ", "$", NumberFormat(pricesFormat(Number(this.state.Accounts.FreightAmt) + Number(this.state.Accounts.TotalCost)))
                                                ]}
                                                bottomStyle={[
                                                    "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "ClearBottom", "LineButtom3Left", "DolarButtomLeft2", "LineButtom3"
                                                ]}
                                                bottomMessage={" "}
                                            />
                                    )

                                }

                            </div>
                            {getValueCookie('CompanyId') === '6' ?
                                <>
                                    <div className='col-sm-6 d-grid gap-2 pb-2'></div>
                                    <div className='col-sm-6 d-grid gap-2 pb-2'>
                                        <InvoiceZebra
                                            id={'InvoicePrintARZebra'}
                                            hidden={true}
                                            colorButton='blackButton'
                                            titleButton='Invoice Print'
                                            title='Invoice Print'
                                            companyLogo={getValueCookie('DocumentsLogo')}
                                            InvoiceType={this.state.select.label}
                                            CompanyContactInfo={['Altitude LLC', '1860 Amwiler Lily Valley Dr', 'Lawrenceville, GA 30045', '(770) 871-5807']}
                                            InvoiceHeader={[['Invoice Number:', this.state.Accounts.InvoiceNo], ['Date:', DateFormatMAS90(this.state.Accounts.InvoiceDate)], ['Grocer:', this.state.Accounts.SalespersonNo], ['Client No:', this.state.Accounts.Customer.CustomerNo], ['Client Name:', this.state.Accounts.Customer.CustomerName], ['Address:', this.state.Accounts.Customer.AddressLine1 + ' ' + this.state.Accounts.Customer.City + ", " + this.state.Accounts.Customer.State + " " + this.state.Accounts.Customer.ZipCode]]}
                                            DescriptionKeys={["ItemCode", "ItemComment", "$", "ItemTotalAmt"]}
                                            HeaderDescritpion={["Code", "Comment", "", "Amount"]}
                                            StyleDetail={["CodeColumn", "MiddleColumn", "SignColumn", "PriceColumn"]}
                                            Detail={this.printDetail("Zebra")}
                                            quantSignDolar={this.realLongDetail()}
                                            keysDecimalFormat={["ItemTotalAmt"]}
                                            bottomInformation={[
                                                ["", "TOTAL", "$", NumberFormat(pricesFormat(Number(this.state.Accounts.FreightAmt) + Number(this.state.Accounts.TotalCost)))]]}
                                            bottomMessage={""}

                                        />
                                    </div>
                                </>
                                :
                                <></>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}